import React from 'react';
import Quiz from './Quiz';
import './App.css';

function App() {
  return (
    <div className="App">
      <Quiz />
    </div>
  );
}

export default App;
